<template>
	<div class="modal is-active">
		<div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title">{{ $t('reminder_modal.title') }}</p>
			</header>
			<section class="modal-card-body">
				<div v-if="mailRecievers.length < 1">
					{{ $t('reminder_modal.confirm_message', { type: $t(`reminder_modal.type.${itemType}`), name: item.name }) }}
				</div>

				<div v-if="mailRecievers.length > 0">
					{{ $t('reminder_modal.sent_to') }}
					<div v-for="(user, index) in mailRecievers" :key="index">
						{{ user }}
					</div>
				</div>
				<div v-if="mailSent">
					{{ $t('reminder_modal.sent_notice') }}
				</div>
			</section>
			<footer class="modal-card-foot">
				<button class="button is-dark" @click.prevent="sendMail" :disabled="disabledSendMail">
					<span v-if="!showSpinner" class="icon"><i class="fas fa-envelope" /></span>
					<span v-if="!showSpinner">{{ $t('reminder_modal.send_button') }}</span>
					<Spinner :showSpinner="showSpinner" />
				</button>

				<button class="button is-dark" @click="cancel">
					<span class="icon"><i class="fas fa-ban" /></span>
					<span>{{ $t('reminder_modal.close_button') }}</span>
				</button>
			</footer>
		</div>
	</div>
</template>

<script>
import Spinner from '@/components/Spinner';
import { mapActions } from 'vuex';
export default {
	components: {
		Spinner
	},
	props: {
		item: {
			type: Object,
			default: () => ({})
		},
		type: String
	},
	data: () => ({
		disabledSendMail: false,
		showSpinner: false,
		mailRecievers: [],
		mailSent: false
	}),
	computed: {
		itemType() {
			return this.type || 'ERROR';
		},
	},
	methods: {
		...mapActions('roundPlanningStore', {
			triggerRoundMail: 'triggerMail'
		}),
		...mapActions('flawStore', {
			triggerFlawMail: 'triggerMail'
		}),
		sendMail() {
			this.showSpinner = true;
			this.disabledSendMail = !this.disabledSendMail;

			if (this.itemType === 'round') {
				this.triggerRoundMail(this.item.id).then(res => {
					this.mailRecievers = res;
					this.showSpinner = false;
				});
			} else if (this.itemType === 'flaw') {
				this.triggerFlawMail(this.item.id).then(res => {
					this.mailRecievers = res;
					this.mailSent = true;
					this.showSpinner = false;
				});
			}
		},
		confirm() {
			this.$emit('confirm');
		},
		cancel() {
			this.$emit('cancel');
		}
	}
};
</script>
